import { useTranslation } from "react-i18next";

import { PsNumericTuner, PsSelectTuner, PsButtonTuner } from "stencilSetup";

export interface LumpSumEntryProps {
  entry: { id: number; amount: string; date: string };
  onDelete: (id: number) => void;
  onInputChange: (id: number, field: string, target: any) => void;
  onBlur: (id: number, field: string, target: any) => void;
  validationMessage: { type: string, message: string } | undefined;
  payCheckDates: string[];
  availableDates: string[];
}

export function LumpSumEntry({ entry, onDelete, onInputChange, onBlur, validationMessage, payCheckDates, availableDates }: LumpSumEntryProps) {
  const { t } = useTranslation('pages.financial');

  const isScreenSmall = window.innerWidth < 922;

  return (
     <div className={isScreenSmall?"":"d-flex align-items-center lump-sum-text"}>
      <div className={`${validationMessage ? 'w-25 mb-1' : 'w-25'} ${isScreenSmall?'w-100':'w-25'}` }>
        <PsNumericTuner
          data-testid={`lump-sum-amount-input-${entry.id}`}
          inputId={`lump-sum-amount-input-${entry.id}`}
          name={`lump-sum-amount-input-${entry.id}`}
          label={t('employeeContribution.lumpSumAmount')}
          value={entry.amount}
          icon="currency-dollar"
          iconLeft={true}
          isInvalid={Boolean(validationMessage?.type === "amount")}
          onInput={(e) => onInputChange(entry.id, 'amount', e.target)}
          onBlur={(e) => onBlur(entry.id, 'amount', e.target)}
          acceptDecimal={true}
        />
        <span className="d-flex align-items-center">
          {(validationMessage && validationMessage.type === "amount" && <div className="align-items-center error-message">{validationMessage.message}</div>)}
        </span>
      </div>
      <div className={`${validationMessage ? 'w-50 mb-5' : 'w-50'} ${isScreenSmall?'w-100':'w-50'}`}>
        <PsSelectTuner
          data-testid={`lump-sum-date-input-${entry.id}`}
          inputId={`lump-sum-date-input-${entry.id}`}
          label={t('employeeContribution.lumpSumDeductionDate')}
          value={entry.date}
          onInput={(e) => onInputChange(entry.id, 'date', e.target)}
          onBlur={(e) => onBlur(entry.id, 'date', e.target)}
          isInvalid={Boolean(validationMessage?.type === "date")}
        >
          <option value=" " selected>Select deduction day</option>
          {payCheckDates.map((date) => (
            <option key={date} value={date} disabled={!availableDates.includes(date)}>
              {new Date(date).toLocaleDateString('en-US', {month: '2-digit', day: '2-digit', year: 'numeric'})}
            </option>
          ))}
        </PsSelectTuner>
      </div>
     
      <div className={`${validationMessage ? 'pb-0_5' : `${isScreenSmall?"pt-2 border-bottom py-3 d-flex justify-content-center" : " pt-5"}`}` }>
        {entry.id > 1 && (
          <PsButtonTuner data-testid='delete-lump-sum' buttonId="delete-lump-sum" id="delete-lump-sum" icon="trash" label={t('employeeContribution.remove')} level="tertiary" onClick={() => onDelete(entry.id)} />
        )}
      </div>
    </div>
  );
};
